import { usePermissionAccess } from './usePermissionAccess';
import { PERMISSIONS } from '@/types/permissions';

/**
 * Hook to check if user has any permissions that allow file uploads
 * Used for showing/hiding UploadQueueWidget and upload-related functionality
 */
export function useUploadPermissions() {
  // Permissions that allow file uploads
  const canImportFile = usePermissionAccess([PERMISSIONS.FILES_ACCESS]);
  const canManageStudyFiles = usePermissionAccess([
    PERMISSIONS.STUDY_FILES_ACCESS,
  ]);
  const canImportWhiteListFile = usePermissionAccess([
    PERMISSIONS.WHITELIST_ACCESS,
  ]);

  // CSV upload permission
  // TODO: Migrate to new permissions - canImportCSV is deprecated
  const canImportCSV = usePermissionAccess([
    PERMISSIONS.CSV_ACCESS,
    PERMISSIONS.CSV_READ_ALL,
  ]);
  // New CSV upload permission
  const canUploadCSV = usePermissionAccess([PERMISSIONS.CSV_UPLOAD]);

  // Future upload permissions can be added here when upload functionality is implemented:
  // const canImportStudy = usePermissionAccess(['canImportStudy']); // when study data file upload is implemented

  return {
    hasAnyUploadAccess:
      canImportFile ||
      canManageStudyFiles ||
      canImportWhiteListFile ||
      canUploadCSV,
    canImportFile,
    canManageStudyFiles,
    canImportWhiteListFile,
    // Legacy - deprecated
    canImportCSV,
    // New CSV permission
    canUploadCSV,
  };
}
